import { ReactNode } from 'react'
import { TableRow, TableCell } from '@/components/ui/table'
import { cn } from '@/lib/utils'
import { Inbox } from 'lucide-react'

interface IntuiTableEmptyProps {
  loading?: boolean
  emptyState?: ReactNode
  colSpan: number
  compact?: boolean
}

function SkeletonRow({ colSpan, compact }: { colSpan: number; compact?: boolean }) {
  return (
    <TableRow>
      {Array.from({ length: colSpan }, (_, i) => (
        <TableCell key={i} className={cn(compact ? 'py-1 px-2' : 'py-2 px-3')}>
          <div className="h-4 w-full rounded bg-muted animate-pulse" />
        </TableCell>
      ))}
    </TableRow>
  )
}

export function IntuiTableEmpty({
  loading,
  emptyState,
  colSpan,
  compact,
}: IntuiTableEmptyProps) {
  if (loading) {
    return (
      <>
        {Array.from({ length: 5 }, (_, i) => (
          <SkeletonRow key={i} colSpan={colSpan} compact={compact} />
        ))}
      </>
    )
  }

  return (
    <TableRow className="hover:bg-transparent">
      <TableCell colSpan={colSpan} className="h-32 text-center">
        {emptyState ?? (
          <div className="flex flex-col items-center justify-center gap-2 text-muted-foreground">
            <Inbox className="h-8 w-8" />
            <span className="text-sm">No data available</span>
          </div>
        )}
      </TableCell>
    </TableRow>
  )
}
